// The one layout switch of the map UI (see docs/ui-layout.md): narrow below WIDE_MIN px, wide from there. CSS repeats the number in its
// media queries (tests/js/layout.test.mjs keeps both equal); everything else is fluid.
export const WIDE_MIN = 1024;
export const WIDE_QUERY = `(min-width: ${WIDE_MIN}px)`;
export const isWide = (win = globalThis) => win.matchMedia?.(WIDE_QUERY).matches ?? false;
